import {InputFileAcceptMimes, InputFileAcceptTypes, ProductTechnicalFileTypes, UploadStates} from "../../../../../core/constants/enums";
import React, {useMemo, useRef, useState} from "react";
import {Col, Row} from "reactstrap";
import {ReactComponent as Placeholder} from "../../../../../assets/images/dropzone/upload-placeholder.svg";
import DropZone from "../../../base/dropzone";
import {ReactComponent as Pdf} from "../../../../../assets/images/file-types/pdf.svg";
import {ReactComponent as Image} from "../../../../../assets/images/file-types/image.svg";
import {ReactComponent as Html} from "../../../../../assets/images/file-types/html.svg";
import {ReactComponent as Unknown} from "../../../../../assets/images/file-types/unknown.svg";
import {createUUId} from "../../../../../core/services/utils/utils";
import Utils from "../../../../../core/services/utils/utils";

const AddProductTechnicalFileDropZone = ({
                                             disabled,
                                             type = ProductTechnicalFileTypes.unknown,
                                             onSuccess,
                                             uploading,
                                             uploadState = {state: UploadStates.done},
                                             id,
                                             file: fileProps,
                                         }) => {
    const [loading, setLoading] = useState(false);
    const idRef = useRef(createUUId(true));

    const hasError = useMemo(() => uploadState.state === UploadStates.error, [uploadState]);
    const accept = useMemo(() => {
        switch (type) {
            case ProductTechnicalFileTypes.HTML:
                return [InputFileAcceptTypes.html]
            case ProductTechnicalFileTypes.PDF:
                return [InputFileAcceptTypes.pdf]
            case ProductTechnicalFileTypes.IMAGE:
                return [InputFileAcceptMimes.images, InputFileAcceptTypes.heic, InputFileAcceptTypes.heif];
            case ProductTechnicalFileTypes.unknown:
            default:
                return [
                    ...Object.values(InputFileAcceptMimes),
                    ...Object.values(InputFileAcceptTypes)
                ]
        }
    }, [type])

    /**
     * Renders the file icon based on the provided type.
     * @return {JSX.Element}
     */
    const fileIcon = useMemo(() => {
        switch (fileProps?.type ?? type) {
            case ProductTechnicalFileTypes.PDF:
                return <Pdf className={'file-icon'}/>;
            case ProductTechnicalFileTypes.HTML:
                return <Html className={'file-icon'}/>;
            case ProductTechnicalFileTypes.IMAGE:
                return <Image className={'file-icon'}/>;
            default:
                return <Unknown className={'file-icon'}/>;
        }
    }, [type, fileProps])

    /**
     * Renders the inner file of the dropzone if the url is available.
     * @return {JSX.Element}
     */
    const file = useMemo(() => {
        switch (fileProps?.type ?? type) {
            case ProductTechnicalFileTypes.HTML:
            case ProductTechnicalFileTypes.PDF:
            case ProductTechnicalFileTypes.unknown:
            default:
                return <div className={'file'}>
                    {fileIcon}
                    <p className={'text-placeholder'}>
                        {fileProps?.name}
                    </p>
                </div>
            case ProductTechnicalFileTypes.IMAGE:
                return <img
                    className='cursor-pointer-hover'
                    src={Utils.encodeFileUrl(fileProps?.url)}
                    alt={`dropzone-${id}`}
                />
        }
    }, [fileIcon, type, fileProps, id])

    return (
        <>
            <DropZone
                id={idRef.current}
                disabled={disabled}
                identifier={'product-technical-file'}
                accept={accept}
                error={hasError}
                onSuccess={onSuccess}
                multiple={false}
                loading={loading}
                uploading={uploading}
                setLoading={setLoading}
                openOnClick
                noParse
                className={`row no-gutters align-items-center justify-content-center `}>
                {() => fileProps?.url?.length > 0
                    ? file
                    : (
                        <Row
                            className={`w-100 no-gutters align-items-center justify-content-center ${uploading ? 'cursor-progress-hover' : ''} ${disabled || loading ? 'cursor-not-allowed-hover' : 'cursor-pointer-hover'}`}>
                            <Col xs={12} className={'d-flex justify-content-center align-items-center'}>
                                <Placeholder/>
                            </Col>
                            <Col xs={12} className={'d-flex flex-column align-items-center'}>
                                {
                                    accept?.length < 3 &&
                                    <p className={'placeholder-text text-sm mb-3'}>
                                        File format: {accept.join(', ')}
                                    </p>
                                }
                                <p className={'placeholder-text'}>
                                    Drag Your File or Click Here to Upload Your File
                                </p>
                            </Col>
                        </Row>
                    )
                }
            </DropZone>
        </>


    );
}

export default AddProductTechnicalFileDropZone;
